import shippingConfig from './shippingTiers.json';

const sortedTiers = () =>
    [...(shippingConfig.tiers || [])].sort((a, b) => b.minSubtotal - a.minSubtotal);

export const shippingForSubtotal = (subtotal) => {
    const tiers = sortedTiers();
    const total = Number(subtotal) || 0;
    const tier = tiers.find((entry) => total >= entry.minSubtotal) || tiers[tiers.length - 1] || {
        minSubtotal: 0,
        amount: 0,
        label: 'Shipping',
    };
    const freeTier = tiers.find((entry) => entry.amount === 0);
    const remaining = freeTier && total < freeTier.minSubtotal
        ? Math.round((freeTier.minSubtotal - total) * 100) / 100
        : 0;
    return {
        amount: Number(tier.amount) || 0,
        label: tier.label || (tier.amount ? 'Standard shipping' : 'Free shipping'),
        remaining,
        freeAt: freeTier?.minSubtotal ?? null,
    };
};

export const FREE_SHIPPING_MINIMUM =
    sortedTiers().find((entry) => entry.amount === 0)?.minSubtotal ?? 50;
